<template>
  <div>
    <es-exception
      v-if="!hasModule('PRSID:DWNLD:DOWNLOAD')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <div class="document-container">
      <div class="columns">
        <div class="column is-three-quarters">
          <div
            class="document"
            style="height:100%"
          >
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Download Options
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-loader v-if="loading"/>
              <div v-else>
              <es-form>
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon
                        :icon="['fas', 'poll']"
                        size="lg"
                      />
                    </div>
                    <div class="header-elements">
                      <label class="title is-size-6">
                        Match Status
                      </label>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <table class="table is-fullwidth">
                    <thead>
                      <th></th>
                      <th
                        class="column-header has-text-grey nowrap"
                        title="Status"
                      >
                        Status
                      </th>
                      <th
                        class="column-header has-text-grey nowrap"
                        title="Submission Date"
                      >
                        Submission Date
                      </th>
                      <th
                        class="column-header has-text-grey nowrap"
                        title="Downloadable Record Count"
                      >
                        Downloadable Record Count
                      </th>
                      <th
                        class="column-header has-text-grey nowrap"
                        title="Total Record Count"
                      >
                        Total Record Count
                      </th>
                    </thead>
                    <tbody
                      v-if="transaction && transactionStatusGroup.length && isDownloadTypesAllowed"
                    >
                      <tr class="batch-category has-text-weight-bold"
                        v-for="(category,index) in transactionStatusGroup"
                        :key="index">
                        <td>
                          <input
                            type="radio"
                            v-model="transGroupCode"
                            :value="category.code"
                            :aria-label="category.code"
                          >
                        </td>
                        <td class="text-align--left">
                          {{ category.groupName }}
                        </td>
                        <td class="text-align--left">
                          {{ formatDateTime(transaction.createdDate) }}
                        </td>
                        <td class="text-align--left">
                          1
                        </td>
                        <td class="text-align--left">
                          1
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <es-exception
                    v-if="!transactionStatusGroup.length || !isDownloadTypesAllowed"
                    style="margin:2rem"
                    exceptionMessage="No records are available for download."
                  />
                </template>
              </es-form>
              <es-form v-if="transactionStatusGroup.length || isDownloadTypesAllowed">
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon
                        :icon="['fas', 'file-edit']"
                        size="lg"
                      />
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Format
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <div class="row removeUnderline">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Download Type
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <div class="buttons has-addons">
                              <button
                                v-for="(option, index) in downloadFormOptions"
                                class="button no-radius"
                                :class="{'selected-option': downloadOption === option}"
                                :key="index"
                                @click="selectType('downloadOption', option)"
                              >
                                {{ option }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="downloadOption === 'Advanced'">
                    <div class="row removeUnderline">
                      <div class="field is-horizontal ">
                        <div class="field-label is-normal">
                          <label class="label">
                            File Format
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <div class="text-align">
                                  {{ personIdFileFormat }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Delimiter
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button
                                  v-for="(item, index) in delimiterOptions"
                                  class="button no-radius"
                                  :class="{'selected-option': delimiter === item.option}"
                                  :key="index"
                                  @click="selectType('delimiter', item.option)"
                                >
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Qualifier
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button
                                  v-for="(item, index) in qualifierOptions"
                                  class="button no-radius"
                                  :class="{'selected-option': qualifier === item.option}"
                                  :key="index"
                                  @click="selectType('qualifier', item.option)"
                                >
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Date Format
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="select is-half-width">
                                <select
                                  aria-label="Date Format"
                                  class="input is-full-width"
                                  v-model="dateFormat"
                                >
                                  <option
                                    v-for="(item, index) in dateFormatOptions"
                                    :key="index"
                                    :value="item.option"
                                  >
                                    {{ item.label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Include Header/Footer
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button
                                  v-for="(item, index) in includeHeaderFooterOptions"
                                  class="button no-radius"
                                  :class="{'selected-option': includeHeaderFooter === item.option}"
                                  :disabled="nearMatchDetails"
                                  :key="index"
                                  @click="selectType('includeHeaderFooter', item.option)"
                                >
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </es-form>
            </div>
            <div
              v-if="transactionStatusGroup.length && isDownloadTypesAllowed"
              class="es-actions"
            >
              <es-form-actions>
                <template #form-actions>
                  <div class="bottom-content">
                    <ul>
                      <li>
                        <div
                          class="list-content"
                          style="padding-right:5rem"
                        >
                          <button
                            class="button is-primary"
                            @click="checkSelectedStatus()"
                          >
                            Generate Extract
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </template>
              </es-form-actions>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-quarter">
        <div class="document" style="height:100%">
          <div class="header">
            <EsHeader>
              <template #header>
                <div class="header-title">
                  Download History
                </div>
              </template>
            </EsHeader>
          </div>
          <div class="content">
            <es-loader v-if="loadingHistory"/>
              <div class="table-wrapper" v-else>
                <table class="table is-fullwidth">
                  <thead>
                    <th class="has-text-grey text-align--left">
                      User ID
                    </th>
                    <th class="has-text-grey text-align--left">
                      Download Date
                    </th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(category,index) in history"
                      class= "form-row"
                      :key="index"
                    >
                      <td class="text-align--left">
                        {{ category.userEmail }}
                      </td>
                      <td class="text-align--left">
                        {{ formatDateTime(category.lastUpdateDate) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="document" v-if="showExtract">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title">
                Extract File (1)
              </div>
            </template>
          </es-header>
        </div>
        <div class="content" >
          <es-loader v-if="loadingExtract"/>
          <div v-else class="table-wrapper">
            <table class="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th title="Extract Date">
                    Extract Date
                  </th>
                  <th title="Location Info">
                    Location Info
                  </th>
                  <th title="Record Count">
                    Record Count
                  </th>
                  <th title="Extract Name">
                    Extract Name
                  </th>
                  <th title="Extract Status">
                    Extract Status
                  </th>
                  <th title="Actions">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ formatExtractDate(extract.createdDate) }}
                    </div>
                    <div>
                      <span class="padding-left--small has-text-grey">
                        {{ formatExtractTime(extract.createdDate) }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="is-flex flex-direction--column">
                      <div>
                        <router-link
                          :to="{
                            name: 'PIDistrictInfoDetails',
                            params: { code: transaction.districtCode  },
                          }"
                          class="has-text-weight-bold has-text-primary"
                          style="font-size:14px"
                        >
                          {{ transaction.districtName }}
                        </router-link>
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ transaction.districtCode }})
                        </span>
                      </div>
                      <div>
                        <router-link
                          :to="{
                            name: 'PISchoolInfoDetails',
                            params: {
                              districtCode: transaction.districtCode,
                              schoolCode: transaction.schoolCode,
                            },
                          }"
                          class="is-italic"
                        >
                          {{ transaction.schoolName }}
                        </router-link>
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ transaction.schoolCode }})
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ extract.totalCount ?  extract.totalCount : "In progress"}} of 1
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ extract.fileName }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ statusName }}
                    </div>
                  </td>
                  <td class="action">
                    <div v-if="(statusId === 3)">
                      <a
                        v-if="extract.fileExtension"
                        :href="buildSplitUrl(extractId)"
                        @click.prevent="downloadFile($event)"
                      >
                        Download
                      </a>
                    </div>
                    <div v-else>
                      <a
                        role="link"
                        tabindex="0"
                        @click="refreshExtract"
                        @keypress="refreshExtract"
                      >
                        Refresh
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
          </table>
          </div>
        </div>
      </div>
      <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faClock,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';
import EsFormActions from '@/components/EsFormActions.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faPoll,
  faFileEdit,
  faClock,
  faSyncAlt,
  faSort,
);
export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
    EsFormActions,
    EsLoader,
    EsException,
  },
  props: [
    'transaction',
  ],
  data() {
    return this.initialData();
  },
  async created() {
    await this.onLoad();
  },
  // watch: {
  //   transGroupCode() {
  //     this.nearMatchDetails();
  //   }
  // },
  computed: {
    ...mapGetters('lookups', [
      'pidTransactionExtractStatuses',
      'pidExtractStatuses',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    allowedExtractDownloadTypes() {
      return this.$store.state.propertiesModule.properties['PERSON-EXTRACT_DOWNLOAD_TYPES_ALLOWED'];
    },
    isDownloadTypesAllowed() {
      if (this.allowedExtractDownloadTypes) {
        return this.allowedExtractDownloadTypes
          .includes(this.transaction.pidBatch.submissionTypeCode);
      } return null;
    },
    formDataBody() {
      const formData = new FormData();
      formData.append('pidBatchId', this.transaction.pidBatchId);
      formData.append('pidSubmissionId', this.transaction.pidSubmissionId);
      formData.append('transGroupCode', this.transGroupCode);
      formData.append('referrer', this.referrer);
      if (this.downloadOption === 'Advanced') {
        formData.append('delimiter', this.delimiter);
        formData.append('qualifier', this.qualifier);
        formData.append('dateFormat', this.dateFormat);
        formData.append('includeHeaderFooter', this.includeHeaderFooter);
      }
      return formData;
    },
    nearMatchDetails() {
      if (this.transGroupCode === 'IDNMD') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.includeHeaderFooter = false;
        return true;
      }
      return false;
    },
    latestId() {
      if (this.history.length !== 0) {
        return this.history.reduce((a, b) => (Number(a.id) > Number(b.id) ? a : b));
      }
      return null;
    },

  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionExtractStatuses',
      'loadPidExtractStatuses',
    ]),
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadPidExtractStatuses(),
          this.loadPidTransactionExtractStatuses(),
        ]);
        this.allTransactionStatusGroup();
        await this.loadHistory();
        if (this.history.length !== (0 || null)) {
          this.extractId = this.latestId.id;
          this.getExtract();
        }
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    allTransactionStatusGroup() {
      this.pidTransactionStatuses = this.pidTransactionExtractStatuses;

      const tranStatusGroups = this.pidTransactionStatuses.map(item => (
        {
          groupName: item.group,
          code: item.code,
          list: item.list,
        }
      )).flat();
      try {
        tranStatusGroups.forEach((groupName, outerIndex) => {
          tranStatusGroups[outerIndex].list.forEach((status, innerIndex) => {
            if (status.id === this.transaction.transStatus) {
              tranStatusGroups[outerIndex].showThisGroup = true;
              tranStatusGroups[outerIndex].list[innerIndex].showThisStatus = true;
            } else {
              tranStatusGroups[outerIndex].list[innerIndex].showThisStatus = false;
            }
          });
        });
      } catch (e) {
        throw e;
      } finally {
        this.transactionStatusGroup = (tranStatusGroups.filter(x => x.showThisGroup)).flat();
      }
      if (this.transactionStatusGroup.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.transGroupCode = this.transactionStatusGroup[0].code;
      }
      return this.transactionStatusGroup;
    },
    checkSelectedStatus() {
      if (this.transGroupCode === null) {
        this.showNotification('danger', [this.statusError]);
      } else {
        this.resetNotifications();
        this.generateExtract();
      }
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildSplitUrl(dlFileId) {
      return `${axios.defaults.baseURL}personid/extracts/${dlFileId}/content`;
    },
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mmA');
    },
    formatExtractDate(value) {
      return moment(value).format('MM/DD/YYYY');
    },
    formatExtractTime(value) {
      return moment(value).format('h:mmA');
    },
    async loadHistory() {
      this.loadingHistory = true;
      try {
        const response = await axios.get('personid/extracts', {
          params: {
            pidBatchId: this.transaction.pidBatchId,
            pidSubmissionId: this.transaction.pidSubmissionId,
          },
        });
        this.history = response.data;
      } catch (error) {
        this.showNotification('danger', ['Error loading history']);
      } finally {
        this.loadingHistory = false;
      }
    },
    async getExtract() {
      try {
        this.loadingExtract = true;
        const response = await axios.get(`personid/extracts/${this.extractId}`);
        this.extract = response.data;
        this.findId = this.extract.extractStatusId;
        this.extractId = this.extract.id;
        this.getExtractStatus();
        this.showExtract = true;
      } catch (error) {
        this.showNotification('danger', ['Error getting extract record']);
      } finally {
        this.loadingExtract = false;
      }
    },
    async generateExtract() {
      try {
        this.showExtract = true;
        this.loadingExtract = true;
        this.resetNotifications();
        const response = await axios.post('personid/extracts', this.formDataBody);
        this.extract = response.data;
        this.findId = this.extract.extractStatusId;
        this.extractId = this.extract.id;
        this.getExtractStatus();
      } catch (error) {
        this.showNotification('danger', ['Error generating extract']);
      } finally {
        this.loadingExtract = false;
      }
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    },
    getExtractStatus() {
      this.extractStatuses = this.pidExtractStatuses;
      this.extractStatuses.forEach((id, outerIndex) => {
        if (this.extractStatuses[outerIndex].id === this.findId) {
          this.statusName = this.extractStatuses[outerIndex].name;
          this.statusId = this.extractStatuses[outerIndex].id;
        }
      });
    },
    selectType(field, option) {
      if (field === 'downloadOption') {
        this.downloadOption = option;
      }
      if (field === 'dmatchFileFormat') {
        this.dmatchFileFormat = option;
      }
      if (field === 'delimiter') {
        this.delimiter = option;
      }
      if (field === 'qualifier') {
        this.qualifier = option;
      }
      if (field === 'includeHeaderFooter') {
        this.includeHeaderFooter = option;
      }
    },
    async refreshExtract() {
      await this.getExtract();
      await this.loadHistory();
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    initialData() {
      return {
        extract: [],
        extractId: null,
        extractStatuses: [],
        findId: null,
        lastDate: null,
        loading: false,
        loadingError: false,
        loadingHistory: false,
        loadingExtract: false,
        history: [],
        pidTransactionStatuses: [],
        showExtract: false,
        statusId: null,
        statusName: null,
        statusObject: [],
        statusError: 'No Status Selected',
        transactionStatuses: [],
        transactionStatusGroup: [],
        transGroupCode: null,
        referrer: 'TRANSPROFILE',
        downloadFormOptions: ['Simple', 'Advanced'],
        downloadOption: 'Simple',
        personIdFileFormat: 'Version 3.0',
        personIdFileFormatOptions: ['Version 3.0', 'Version 2.1', 'Version 1.0'],
        delimiter: '09',
        delimiterOptions: [
          { label: 'Tab', option: '09' },
          { label: 'Comma', option: ',' },
        ],
        qualifier: null,
        qualifierOptions: [
          { label: 'Double Quotes ( " )', option: '"' },
          // We may need Single Quote back in the future.
          // { label: "Single Quote ( ' )", option: "'" },
          { label: 'None', option: null },
        ],
        includeHeaderFooter: true,
        includeHeaderFooterOptions: [
          { label: 'Yes', option: true },
          { label: 'No', option: false },
        ],
        dateFormat: 'MM/dd/yyyy',
        dateFormatOptions: [
          { label: 'mm/dd/yyyy', option: 'MM/dd/yyyy' },
          { label: 'ISO Format (YYYY-MM-DD)', option: 'YYYY-MM-dd' },
          { label: 'mm/d/yyyy', option: 'MM/d/yyyy' },
          { label: 'm/d/yyyy', option: 'M/d/yyyy' },
          { label: 'm/dd/yyyy', option: 'M/dd/yyyy' },
        ],
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  .margin-bottom
    margin-bottom: 1rem
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    &:before, &:after
    border: 4px solid transparent
    content: ""
    display: block
    height: 0
    right: 5px
    top: 50%
    position: absolute
    width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
      &:after
        border-top-color: #999
        margin-top: 1px
  .header-container
    margin-bottom: 1rem
  .no-radius
    border-radius: 0
    background-color: #F2F2F2
    font-weight: normal
  .selected-option
    background-color: #ccc
    font-weight: bold
  .fields-container
    margin-left: 30px
  .text-align--left
    text-align: left !important
  .column-header
    padding-left: 0px
  .text-align--right
    text-align: right !important
  .text-align--left
    text-align: left !important
  @media screen and (max-width: 60em)
    .columns
      display: block
      .column
        width: 100%
  .table-wrapper
    overflow-x: auto
</style>
